import { api } from "./client.js";
import type { AdminPassportRow, AdminProductRow, AdminUserRow, Page, PlatformOverview } from "../types.js";

/**
 * Typed wrappers for the platform-admin console (cross-tenant, platform
 * permissions). Unlike api/dpp.ts these are NOT org-scoped by design.
 */

type Query = Record<string, string | number | boolean | undefined>;

function qs(params: Query): string {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== "" && v !== false) sp.set(k, String(v));
  }
  const s = sp.toString();
  return s ? `?${s}` : "";
}

export function getPlatformOverview(includeDemo: boolean): Promise<PlatformOverview> {
  return api<PlatformOverview>(`/admin/overview${qs({ includeDemo })}`);
}

export interface CrossTenantParams {
  search?: string | undefined;
  orgId?: string | undefined;
  status?: string | undefined;
  includeDemo?: boolean | undefined;
  limit: number;
  offset: number;
}

export function listAllProducts(p: CrossTenantParams): Promise<Page<AdminProductRow>> {
  return api<Page<AdminProductRow>>(`/admin/products${qs({ ...p })}`);
}

export function listAllPassports(p: CrossTenantParams): Promise<Page<AdminPassportRow>> {
  return api<Page<AdminPassportRow>>(`/admin/passports${qs({ ...p })}`);
}

export interface UserDirectoryParams {
  search?: string | undefined;
  status?: "active" | "disabled" | undefined;
  withoutOrg?: boolean | undefined;
  includeDemo?: boolean | undefined;
  limit: number;
  offset: number;
}

export function listUserDirectory(p: UserDirectoryParams): Promise<Page<AdminUserRow>> {
  return api<Page<AdminUserRow>>(`/admin/user-directory${qs({ ...p })}`);
}

export function setUserPassword(userId: string, password: string): Promise<void> {
  return api<void>(`/admin/users/${userId}/password`, { method: "POST", body: { password } });
}

export function unlockUser(userId: string): Promise<void> {
  return api<void>(`/admin/users/${userId}/unlock`, { method: "POST" });
}
